<svg:g xmlns:svg="http://www.w3.org/2000/svg" chart-axis [config]="axisConfig"></svg:g>
<svg:g xmlns:svg="http://www.w3.org/2000/svg"  class="bars">
    <svg:g *ngFor="let barsi of bars;let i=index" [class.bar-stack-group]="config.isStacked">
        <svg:g *ngFor="let rec of barsi;let j=index" class="bar-group" (mouseover)="hoveredIndex=i" (mouseout)="hoveredIndex=-1" container="body" ngbPopover="{{rec.text}}" triggers="mouseenter:mouseleave" popoverTitle="{{config.data.labels[i] + (labels[j] ? (':' + labels[j]) : '') }}">
            <svg:rect class="rect" rx="2" [attr.width]="rec.width" [attr.height]="rec.height" [attr.x]="rec.x" [attr.y]="rec.y" [attr.fill]="rec.fill || '#07a'"></svg:rect>
        </svg:g>

    </svg:g>
</svg:g>

<!-- Series legend (multi-series only) — top-right, clear of the usually-tall left bars. -->
<svg:svg class="legend-container" xmlns:svg="http://www.w3.org/2000/svg"
         *ngIf="config.showLegend && labels && labels.length > 1"
         x="0" y="0" height="100%">
    <svg:text text-anchor="end"
              [attr.x]="config.chartWidth - config.xPadding - xOffsets"
              y="12"
              font-size="11"
              font-weight="600"
              letter-spacing="0.02em">
        <svg:tspan *ngFor="let lab of labels; let i = index"
                   class="legend"
                   [attr.fill]="config.colors[i % config.colors.length]">
            <svg:tspan>●&nbsp;</svg:tspan>
            <svg:tspan>{{lab}}</svg:tspan>
            <svg:tspan *ngIf="i < labels.length - 1" dx="14">&nbsp;</svg:tspan>
        </svg:tspan>
    </svg:text>
</svg:svg>

